import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    minHeight: 500,
  },
  titleWrapper: {
    width: '100%',
    padding: 20,
    textAlign: 'center',
    borderBottom: '1px solid #929292',
  },
  title: {
    fontSize: '20px',
    lineHeight: '23px',
  },
  main: {
    width: '90%',
    padding: '25px 0',
  },
  card: {
    backgroundColor: theme.backgrounds.cardBackground,
    padding: '3% 10%',
    marginBottom: 22,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    minHeight: 100,
  },
  blockTitle: {
    color: 'rgba(229, 229, 229, 0.67)',
    fontSize: '18px',
    marginBottom: 5,
  },
  blockType: {
    fontSize: '18px',
  },
  submitButton: {
    width: '100%',
    height: 50,
    marginTop: 20,
    marginBottom: 40,
  },
  webView: {
    background: theme.webView.background,
  },
  buttonThirdSize: {
    width: '100%',
    marginTop: 15,
    marginBottom: 15,
  },
  andOrButtions: {
    marginRight: 5,
    color: theme.typography.color,
    borderColor: theme.palette.shadow.color,
  },
  thenButton: {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.texts.main,
  },
  buttonThirdSizeWrapper: {
    width: '90%',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
  },
  sceneCreatingAdditionalWrapper: {
    width: '100%',
    borderTop: '1px solid #929292',
    marginTop: 35,
  },
}))

export default useStyles
